import { AddressTransactionsFilterTxType } from '@apolloGenerated';

export default (txType: AddressTransactionsFilterTxType) => {
  return txType === AddressTransactionsFilterTxType.Sent
    ? AddressTransactionsFilterTxType.Receives
    : AddressTransactionsFilterTxType.Sent;
};
